import axiosInstance from "./axiosInstance";

export interface ApiCity {
  cityId: number;
  cityName: string;
  cityCode: string | null;
  postalCode?: string | null;
  countryId: number;
  isActive: boolean;
}

export interface ApiCountryWithCities {
  countryId: number;
  countryName: string;
  iso2: string;
  iso3: string;
  dialCode?: string | null;
  isActive: boolean;
  cities: ApiCity[];
}

export interface CountryCityQuery {
  searchText?: string;
  countryName?: string;
  countryCode?: string;
  countryIsActive?: boolean | null;
  cityIsActive?: boolean | null;
  countriesWithNoCities?: boolean;
}


export interface CountryCityFilterPayload {
  searchText?: string;
  countryName?: string;
  countryCode?: string;
  countryIsActive?: boolean;
  cityIsActive?: boolean;
  countriesWithNoCities?: boolean;
}

export interface CountriesWithCitiesQuery {
  searchText?: string | null;
  countryName?: string | null;
  countryCode?: string | null;
  countryIsActive?: boolean | null;
  cityIsActive?: boolean | null;
  countriesWithNoCities?: boolean;
}

export const getAuthHeader = () => {
  const token = localStorage.getItem("fhims_auth_token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const getCountriesWithCities = async (
  payload: CountriesWithCitiesQuery
): Promise<ApiCountryWithCities[]> => {
  const res = await axiosInstance.post(
    "/City/countries-with-cities/query",
    payload,{
      headers: getAuthHeader(),
    }
  );
  return res.data;
};

// GET: /City  (get all cities)
export const getAllCities = async () => {
  const res = await axiosInstance.get("/City", {
    headers: getAuthHeader(),
  });
  return res.data; 
};

// POST: /City
export const addCity = async (payload: {
  cityName: string;
  cityCode: string | null;
  postalCode: string;
  countryId: number;
  isActive: boolean;
}) => {
  const res = await axiosInstance.post("/City", payload, {
    headers: getAuthHeader(),
  });
  return res.data;
};

export const getCountriesWithCitiesFiltered = async (
  payload: CountryCityFilterPayload
) => {
  const res = await axiosInstance.post(
    "/City/countries-with-cities/query",
    payload, {
      headers: getAuthHeader(),
    }
  );
  return res.data;
};

export const getCountriesWithCitiesQuery = async (
  payload: CountriesWithCitiesQuery
): Promise<ApiCountryWithCities[]> => {
  const res = await axiosInstance.post(
    "/City/countries-with-cities/query",
    payload, {
      headers: getAuthHeader(),
    }
  );
  return res.data;
};

// POST new country
export const addCountry = async (payload: {
  countryName: string;
  iso2: string;
  iso3: string;
  dialCode: string;
  isActive: boolean;
  createdBy: number;
}) => {
  const res = await axiosInstance.post("/Country", payload, {
    headers: getAuthHeader(),
  });
  return res.data;
};

// PUT: /City  (update existing city)
export const updateCity = async (payload: {
  cityId: number;
  cityName: string;
  cityCode: string;
  postalCode: string;
  countryId: number;
  isActive: boolean;
}) => {
  const res = await axiosInstance.put("/City", payload, {
    headers: getAuthHeader(),
  });
  return res.data;
};


// DELETE: /City/{id}
export const deleteCity = async (cityId: number) => {
  const res = await axiosInstance.delete(`/City/${cityId}`,{
    headers: getAuthHeader(),
  });
  return res.data; 
};

// PUT: /Country  (update existing country)
export const updateCountry = async (payload: {
  countryId: number;
  countryName: string;
  iso2: string;
  iso3: string;
  dialCode: string;
  isActive: boolean; 
  updatedBy: number;
}) => {
  const res = await axiosInstance.put("/Country", payload,{
    headers: getAuthHeader(),
  });
  return res.data;
};

// DELETE: /Country/{countryId}
export const deleteCountry = async (countryId: number) => {
  const res = await axiosInstance.delete(`/Country/${countryId}`,{
    headers: getAuthHeader(),
  });
  return res.data; 
};

// PUT: /Country/{countryId}/inactive
export const inactivateCountry = async (countryId: number) => {
  const res = await axiosInstance.put(`/Country/${countryId}/inactive`,{},{
    headers: getAuthHeader(),
  });
  return res.data; 
};
